<template>
 
  <!-- <HelloWorld msg="Top page"/> -->
  <main>
    <div v-if="loadingMask" class="loadingMask"></div>
    <div v-if="showGlobalMessage" class="globalMessage"><span v-html="globalMessage"></span></div>
    <span v-if="user != null" class="logout"><a href="/" class="breadCrumbs"> Home </a> <span>Hi {{user.first_name}} {{user.last_name}}</span>, <span class='link'><a href="/logout"><u>Log Out</u></a></span></span>

    <RouterView @displayGlobalMessage="handleDisplayGlobalMessage" @logout="logout" @login="login"/>
  </main>
  <footer>Copyright  <img src="Copyright.svg" alt=""> {{new Date().getFullYear()}} Brighton Employee Portal</footer>
</template>

<script>
// import HelloWorld from './components/HelloWorld.vue'
import Cookies from 'js-cookie'
export default {
  name: 'App',
  components: {
    // HelloWorld
    
  },
  data() {
    return {
      lastCheckInTime: null,
      globalMessage: '',
      showGlobalMessage: false,
      timeID: null,
      loadingMask: false,
      user: null
    }
  },
  methods: {
    logout(){
      this.user = null
    },
    login() {
      let token = this.getSiteCookie('btoken')
        this.user = localStorage.getItem(token)
      if(this.user != undefined)
        this.user = JSON.parse(this.user)
    },
    handleDisplayGlobalMessage(payload) {
      let that = this
      // console.log(payload)
      this.showGlobalMessage = payload.on
      if(payload.on) {
        this.globalMessage = payload.message + '&nbsp;'
        if(payload.animate) {
          this.timeID = setInterval(function(){
            if(that.globalMessage == payload.message + '.&nbsp;&nbsp;')
              that.globalMessage = payload.message + '..&nbsp;'
            else if(that.globalMessage == payload.message + '..&nbsp;')
              that.globalMessage = payload.message + '...'
            else if(that.globalMessage == payload.message + '...')
              that.globalMessage = payload.message + '&nbsp;&nbsp;&nbsp;'
            else 
              that.globalMessage = payload.message + '.&nbsp;&nbsp;'
          }, 300)
        } else
            clearInterval(this.timeID)
        }



      // setTimeout(function(){
        // that.globalMessage = ''
      // }, payload.duration)
    },
    checkLogin () {
      let token = this.getSiteCookie('btoken')
      if(token != undefined && localStorage.getItem(token) != undefined) {
        let url = process.env.VUE_APP_API_BASE_URL+"/keepAlive"
        let config = {
          method: 'post',
          maxBodyLength: Infinity,
          url,
          headers: { 
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          },
          data : {}
        };
        this.axios.request(config).then((response) => { 
          if(!response.data.success) {
            console.log(response)
            console.log('Token expired.... redirecting to login...')
            localStorage.clear();
            Cookies.remove('btoken');
            this.$router.push('/login');
          } else {
            console.log('resetting counter')
            this.lastCheckInTime = Date.now()
          }
        })
      } else {
        localStorage.clear();
        Cookies.remove('btoken');
        console.log('redirecting to login1')
        this.$router.push('/login');
      }
    },
    getSiteCookie(name) {
      const value = Cookies.get(name);
      return value
    },
  },
  mounted() {
    let that = this
    console.log(process.env, 'envionment vars')
    // this.apiURL = process.env.NODE_ENV == 'development' ? 'http://localhost:3000' : `/api/`
    // to use other service's ip address
    // in Kubernetes process.env.AUTH_SERVICE_SERVICE_HOST
    // or if use docker compopse ...use <SERVICE_NAME> 
    this.checkLogin()
    setInterval(function () {
      that.checkLogin()
    }, 60000)

    let token = this.getSiteCookie('btoken')
      this.user = localStorage.getItem(token)
    if(this.user != undefined)
      this.user = JSON.parse(this.user)
        


    console.log('App mounted')
  }
}
</script>

<style lang="scss">
  html {
    /* background-color:#ebebeb; */
    /* letter-spacing: .03em; */
    /* font: 14px / 20px 'Montserrat', Arial, Helvetica, sans-serif; */
  }

  #app {

    h1{
      padding-bottom:35px;
      text-align: center;
    }
    /* box-shadow: 3px 3px 3px rgba(0, 0, 0, 0.2); */
    .logout {
      text-align: right;
      display: block;
      padding:20px;
      span{
        display:inline-block;
      }
      .breadCrumbs{
        float:left;
        font-weight: bold;
        text-decoration: underline;
      }
      .link {
        cursor: pointer;
        padding-left:4px;
        display:inline-block;
        
      }
    }
    main{
      min-height:500px;
      background-color:white;
      /* padding:20px; */
      border-radius: 5px;
      border: 1px solid #ccc;
      width:calc(100% - 55px);
      box-sizing:border-box;
      margin:0 auto;
      
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
      text-align: center;
      color: #2c3e50;
      margin-top: 20px;
      max-width:1270px;
      position:relative;
      input[type=password] {
        border: 2px solid #b3b3b3;
        outline: 0;
      }
      .loadingMask{
        z-index:1;
        background:rgba(255,255,255,0.8);
        position:absolute;
        left:0;
        width:100%;
        height:100%;
        top:0;
      }
      .globalMessage{
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(255,255,255, 0.8);
        z-index: 2;
        span {
          text-transform: uppercase;
          /* width:100px; */
          font-weight:bold;
          margin-top: 100px;
          display:block; 
          position:relative;
          top:25%;
          width:100%;
        }
      }

    }
  }
  footer{
    display:block;
    height:20px;
    text-align: center;
    padding:20px 0;
    /* font-weight:bold; */
    text-transform: uppercase;
    img{
      width: 14px;
      display: inline-block;
      vertical-align: text-top;
    }
  }
  .vuejs3-datepicker__value{
    border-radius: 0 !important;
    border: 2px solid #b3b3b3 !important;
    height: 27px !important;
    padding:0 5px !important;
  }
  .vuejs3-datepicker__icon{
    padding-top:3px !important;
  }
</style>
